import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import Footer from './components/Footer';
import Navbar from './components/Navbar';
import ScrollToTop from './components/ScrollToTop';
import HomePage from './pages/HomePage';
import Contact from './pages/Contact';
import AboutUsPage from './pages/AboutUs';
import WebsiteDevelopment from './pages/WebsiteDevelopment';
import WebAppDevelopment from './pages/WebAppDevelopment';
import SeoPerformance from './pages/SeoPerformance';
import NotFound from './pages/NotFound';
import Pricing from './pages/Pricing';

function AppContent() {
  const location = useLocation();
  const isNotFound = !["/", "/Contact", "/about-us", "/pricing", "/services/website-development", "/services/web-application-development", "/services/seo-performance"].includes(location.pathname);

  return (
    <div>
      <ScrollToTop />
      {!isNotFound && <Navbar />}
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/Contact" element={<Contact />} />
        <Route path="/about-us" element={<AboutUsPage />} />
        <Route path="/services/website-development" element={<WebsiteDevelopment />} />
        <Route path="/services/web-application-development" element={<WebAppDevelopment />} />
        <Route path="/services/seo-performance" element={<SeoPerformance />} />
        <Route path="/pricing" element={<Pricing />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
      {!isNotFound && <Footer />}
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AppContent />
    </BrowserRouter>
  );
}

export default App;
